import React, { useEffect, useState } from "react";
import { getSideIndexList } from "./sideIndexItems";

import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function SideIndex({ setCont, name, subType }) {
	const [selList, setSelList] = useState(null);
	const [indexList, setIndexList] = useState(null);
	const [value, setValue] = useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const setMenu = (name) => {
		if (selList) {
			selList.classList.remove("active");
		}
		const btnElem = document.getElementById(name);
		const listItem = btnElem.parentElement;
		listItem.classList.add("active");
		setSelList(listItem);
		setCont(name);
	};

	useEffect(() => {
		if (indexList) {
			setMenu(subType ? subType : indexList.list[0].id);
		}
	}, [indexList]);

	useEffect(() => {
		setIndexList(getSideIndexList(name));
	}, [name]);

	return (
		<>
			<div className="mobile-menu-side">
				<Box sx={{ maxWidth: "100%", bgcolor: "background.paper" }}>
					<Tabs
						value={value}
						onChange={handleChange}
						variant="scrollable"
						scrollButtons
						allowScrollButtonsMobile
					>
						{indexList
							? indexList.list.map((item, index) => (
									<Tab
										key={index}
										value={index}
										label={item.label}
										onClick={(e) => setMenu(item.id)}
										wrapped
									/>
							  ))
							: ""}
					</Tabs>
				</Box>
			</div>
			<div className="side-menu">
				{indexList ? (
					<aside>
						<ul className="side-navigation">
							<li className="category">{indexList.category}</li>
							<ul className="article_links">
								{indexList.list.map((item, index) => (
									<li
										key={item.id}
										className={
											subType === item.id
												? "article-link-item active"
												: "article-link-item "
										}
									>
										<button
											id={item.id}
											className="link_button_sd"
											onClick={(e) => setMenu(item.id)}
										>
											{item.label}
										</button>
									</li>
								))}
							</ul>
						</ul>
					</aside>
				) : (
					""
				)}
			</div>
		</>
	);
}
